import React,{ useState, useEffect } from 'react';
import { useNavigate  } from 'react-router-dom';
import { Col, Row } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined  } from '@ant-design/icons';


import './BaseButton.less'

//   btnConfig:{
//     text: 'Learn more',
//     link: ''
//   }
const BaseButton = ({style, btnConfig}) =>{
  const navigate = useNavigate()


  return (
    <button className="BaseButton" onClick={()=> navigate(btnConfig.link)} style={style}>
      {btnConfig.text} <ArrowRightOutlined style={{marginLeft:20}}/>
    </button>
  )
}

export default BaseButton